import PageHeader from "@/components/site/PageHeader";
import PageTitle from "@/components/site/PageTitle";
import KineticMarquee from "@/components/site/KineticMarquee";
import { PROGRAMS } from "@/lib/content";
import * as Icons from "lucide-react";
import { Link } from "react-router-dom";
import { ArrowUpRight, CheckCircle2 } from "lucide-react";
import CTASection from "@/components/site/CTASection";

export default function ProgramsPage() {
  return (
    <main data-testid="programs-page">
      <PageTitle title="Programs" suffix="RoboInSci by Gakuen" />
      <PageHeader
        eyebrow="Programs"
        code="01"
        kicker="Curriculum"
        title={
          <>
            Five tracks. Built for{" "}
            <span className="italic font-display-soft">institutional</span>{" "}
            depth.
          </>
        }
        lead="Robotics, Gen AI, IoT, App Development and 3D Design — every track is curriculum-aligned, mentor-led and outcomes-graded."
      />
      <KineticMarquee variant="light" items={["Robotics", "Gen AI", "IoT", "App Dev", "3D Printing", "Mentorship"]} />

      <section className="border-t border-[var(--ri-ink)] bg-white">
        <div className="ri-container py-16 md:py-24 space-y-px">
          {PROGRAMS.map((p, i) => {
            const Icon = Icons[p.icon] || Icons.Cpu;
            return (
              <article
                key={p.slug}
                data-testid={`program-detail-${p.slug}`}
                className="grid lg:grid-cols-12 gap-8 lg:gap-12 border border-[var(--ri-ink)] p-7 md:p-10"
              >
                <div className="lg:col-span-2 flex lg:flex-col items-center lg:items-start justify-between lg:justify-start gap-4">
                  <div className="font-display text-6xl md:text-7xl text-[var(--ri-orange)] leading-none">
                    0{i + 1}
                  </div>
                  <Icon size={40} strokeWidth={1.4} />
                </div>
                <div className="lg:col-span-6">
                  <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ri-muted)]">
                    {p.code}
                  </span>
                  <h2 className="mt-2 font-display text-4xl md:text-5xl leading-[1.02] tracking-tight">
                    {p.title}
                  </h2>
                  <p className="mt-4 text-[var(--ri-muted)] text-base leading-relaxed">
                    {p.blurb}
                  </p>
                  <div className="mt-6 flex flex-wrap gap-3">
                    <span className="ri-tag">Duration: {p.duration}</span>
                    <span className="ri-tag">Level: {p.level}</span>
                  </div>
                </div>
                <div className="lg:col-span-4 border-l-0 lg:border-l lg:pl-8 border-[var(--ri-ink)]">
                  <div className="overline mb-4">Outcomes</div>
                  <ul className="space-y-3">
                    {p.outcomes.map((o) => (
                      <li key={o} className="flex items-start gap-3 text-sm">
                        <CheckCircle2
                          size={16}
                          className="text-[var(--ri-orange)] mt-0.5 flex-shrink-0"
                        />
                        <span>{o}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/contact"
                    className="btn-primary mt-7"
                    data-testid={`program-cta-${p.slug}`}
                  >
                    Enquire <ArrowUpRight size={14} />
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      <CTASection />
    </main>
  );
}
